import styled, { css } from 'styled-components';

type PreviewContainerProps = {
  withControls?: boolean;
  isPdf?: boolean;
};

export const PreviewContainer = styled.div<PreviewContainerProps>`
  img {
    height: 100%;
  }

  ${({ withControls }) =>
    withControls &&
    css`
      .image-control img {
        padding: 16px !important;
        background-color: ${({ theme }) => theme.colors.background.primary};
      }
    `}

  /* PDF: o modal abre com width auto — sem isso o viewer encolhe e fica ilegível */
  ${({ isPdf }) =>
    isPdf &&
    css`
      /* o modal envolve o conteúdo (shrink-to-fit), então % colapsa; a largura
         precisa ser definida e SEMPRE menor que os 80vw do modal do FilesList —
         90vw transbordava em janelas estreitas (QA CORE-3389) */
      width: min(900px, 78vw);
      max-width: 100%;
      height: 85vh;
      display: flex;
      flex-direction: column;
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
    `}
`;

export const Embed = styled.embed`
  width: 60vw;
  height: 80vh;
`;

export const Object = styled.object`
  width: 60vw;
  height: 80vh;
`;

export const LoadingWrapper = styled.div`
  min-width: 300px;
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    color: ${({ theme }) => theme.colors.brand.primary};
    width: 24px;
    height: 24px;
  }
`;
